import { FC, useRef } from "react";
import { Drawer as AntdDrawer, ConfigProvider } from "antd";
import { useLockScroll } from "@/hooks";

import type { DrawerProps } from "antd/";

export type IDrawerProps = DrawerProps

export interface LoIDrawerProps extends IDrawerProps {
  isScrollV2?: boolean;
}

const Drawer: FC<LoIDrawerProps> = (props) => {

  const { children, isScrollV2 = false, ...otherProps } = props;

  const ref = useRef<HTMLDivElement>(null)
  useLockScroll(ref, otherProps?.open ? 'strict' : false, isScrollV2);

  return (
    <AntdDrawer
      {...otherProps}>
      <div ref={ref} className="antd-drawer-ref">
        {children}
      </div>
    </AntdDrawer>
  )
}

export default Drawer;
